import BulkVehicleOnly from './BulkVehicleOnly';
import RecovrAndVehicle from './RecovrAndVehicle';
import PendingSale from './PendingSale';
import C from '../Constants';
export default {
  [C.SALE_TYPES.DEALER_TRADE]: BulkVehicleOnly,
  [C.SALE_TYPES.VEHICLE_WITH_LOCATOR]: RecovrAndVehicle,
  [C.SALE_TYPES.VEHICLE_ONLY]: BulkVehicleOnly,
  [C.SALE_TYPES.VEHICLE_WHOLESALE]: BulkVehicleOnly,
  'pending-sale': PendingSale
};